import React from "react";
import PropTypes from "prop-types";

import { Input } from "rbx";

// const splice = (str, start, delCount, newSubstr) =>
//   str.slice(0, start) + newSubstr + str.slice(start + Math.abs(delCount));

function TimeInput({ name, label, value, onChange, ...props }) {
  return (
    <Input
      autocomplete="new"
      type="time"
      {...props}
      id={label}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
}

TimeInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

export default TimeInput;
